import { Capacitor } from '@capacitor/core'
import { LocalNotifications } from '@capacitor/local-notifications'
import { StateCreator } from 'zustand'
import { BoundStore } from '../bound.store'
import { LocalNotificationsSlice } from './localNotifications.interface'

export const createLocalNotificationsSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    LocalNotificationsSlice
> = (set, get) => ({
    scheduleLocalNotifications: false,
    notificationPermissionsGranted: false,
    notificationFilters: {},
    notificationIds: [],
    widgetFilters: undefined,
    setScheduleLocalNotifications: (scheduleLocalNotifications: boolean) => {
        set((state) => ({
            ...state,
            scheduleLocalNotifications,
        }))
    },
    syncNotificationPermissions: async () => {
        if (Capacitor.getPlatform() === 'web') {
            set((state) => ({
                ...state,
                notificationPermissionsGranted: true,
            }))
            return
        }
        const permission = await LocalNotifications.checkPermissions()
        if (permission.display === 'granted') {
            set((state) => ({
                ...state,
                notificationPermissionsGranted: true,
            }))
        } else {
            set((state) => ({
                ...state,
                notificationPermissionsGranted: false,
            }))
        }
    },
    notificationFilterToggleItinerary: (
        itineraryId: number,
        sectionIds: number[]
    ) => {
        const { notificationFilters } = get()
        if (Object.keys(notificationFilters).includes(itineraryId.toString())) {
            const newFilters = { ...notificationFilters }
            delete newFilters[itineraryId]
            set((state) => ({
                ...state,
                notificationFilters: newFilters,
            }))
        } else {
            set((state) => ({
                ...state,
                notificationFilters: {
                    ...notificationFilters,
                    [itineraryId]: sectionIds,
                },
            }))
        }
    },
    notificationFilterToggleSection: (
        sectionId: number,
        itineraryId: number
    ) => {
        const { notificationFilters } = get()
        const itineraryFilter = notificationFilters[itineraryId]

        let newFilters = { ...notificationFilters }

        if (itineraryFilter) {
            if (itineraryFilter.includes(sectionId)) {
                const updatedSections = itineraryFilter.filter(
                    (id) => id !== sectionId
                )

                if (updatedSections.length === 0) {
                    delete newFilters[itineraryId]
                } else {
                    newFilters[itineraryId] = updatedSections
                }
            } else {
                newFilters[itineraryId] = [...itineraryFilter, sectionId]
            }
        } else {
            newFilters[itineraryId] = [sectionId]
        }

        set((state) => ({
            ...state,
            notificationFilters: newFilters,
        }))
    },
})
